export default {
  zh: {
    payment: "支付信息",
    feeDetails: "费用详情",
    package: "套餐",
    customized: "定制化服务",
    supplemental: "补款",
    taxExcluded: "不含税",
    taxAmount: "税额",
    totalAmountDue: "应付金额合计",
    amountInRMB: "人民币金额: ",
    transferReminder: "支持扫描下方二维码，或通过银行转账进行购买；",
    transferNotice: "转账须知: ",
    combo: "确认套餐",
    amends: "确认补款",
    currentPrice: "现价：",
    originalPrice: "原价：",
    payType: "支付方式",
    alipay: "支付宝扫码(专项)",
    scanHint: "扫码付款(仅限人民币支付)",
    bank: "银行转账",
    payNow: "SG PayNow支付",
    gathering: "银行转账",
    indication: "转款时需注明“交易代码”",
    bankName: "收款行名称:",
    accountName: "收款人名称:",
    companyAddress: "收款人地址:",
    accountNumber: "收款人账号:",
    swiftCode: "Swift 代码:",
    bankAddress: "收款行地址:",
    transferVoucher: "转账凭证",
    upload: "上传转账凭证",
    explain: "提示说明:",
    explainText01: "- 确认信息和电子发票将在申请完成后发送至申请者的电邮，后续将持续更新申请的状态;",
    explainText02: "- 因特殊原因（如反洗钱等）导致申请失败的，一经双方确认，申请费扣除$100手续费、已支付给政府Gov的费用、以及银行手续费后的余额将退还给申请者;",
    explainText03: "- 若存在进一步补充信息需求，EStar将安排专人通过电邮进行跟进;",
    explainText04: "- 请注意：本次待付款的申请文件仅在线上自动保存30天。若30天内未完成付款，该申请将被系统删除，因此请您及时安排相应的付款;",
    rule: "计价规则: ",
    price: "价格",
    discount: "人民币价格折算一般按： 新币价格 * ",
    sketch:
      "为方便您的支付，我们提供以人民币金额结算的支付方式。上述人民币金额是基于外汇转换汇率以及因提供人民币支付便利而新增的附加服务费用综合计算得出。您可以根据您的实际情况及需求选择本页面提供的不同的支付方式。",
    or: "或",
    transactionNo: "交易代码",
    alipayTransfer: "支付宝转账(常用)",
    paymentInstructions: "支付须知: ",
    alipaySpecial: "收款二维码(专项)：须在本订单提交完成后的2小时内完成支付，否则二维码失效；",
    alipayGeneral: "收款二维码(常用)：转款时需注明“交易代码”，二维码长期有效。",
  },
  en: {
    payment: "Payment",
    feeDetails: "Fee Details",
    package: "Package",
    customized: "Customized service",
    supplemental: "Supplemental",
    taxExcluded: "Tax excluded",
    taxAmount: "Tax amount",
    totalAmountDue: "Total amount due",
    amountInRMB: "Amount (RMB): ",
    transferReminder: "You can make your purchase by scanning the QR code below or via bank transfer.",
    transferNotice: "Bank Transfer Instructions: ",
    combo: "Confirmation:",
    amends: "Confirm the supplemental",
    currentPrice: "current price: ",
    originalPrice: "original price: ",
    payType: "Mode of payment",
    alipay: "Alipay (Special)",
    scanHint: "Scan code (RMB only)",
    bank: "Bank Transfer",
    payNow: "SG PayNow pay",
    gathering: "Bank Transfer",
    indication: '"Transaction No." shall be indicated when making the payment.',
    bankName: "Name of receiving bank: ",
    accountName: "Name of payee: ",
    companyAddress: "Payee address: ",
    accountNumber: "Account number of payee: ",
    swiftCode: "Swift Code: ",
    bankAddress: "Address of receiving bank: ",
    transferVoucher: "transfer voucher",
    upload: "Upload documents",
    explain: "Notes:",
    explainText01:
      "- An acknowledgement message and an e-invoice will be provided via email upon application. The update of applicatoin status will be provided subsequently via email.",
    explainText02:
      "- If the application fails due to special reasons (such as anti-money laundering, etc.), the balance of the application fee after deducting $100 handling fee, fees paid to Gov and bank charges will be refunded to the applicant upon confirmation by both parties.",
    explainText03: "- If there is a need for any further supplementary information, EStar will arrange staff to follow up via email.",
    explainText04:
      "- Please note: this application file will be automatically saved online for 30 days only. If the payment is not completed within 30 days, the application will be deleted by the system, so please timely arrange the corresponding payment.",
    rule: "Pricing rules:",
    price: "price",
    discount: "RMB price conversion is generally calculated as follows: Singapore dollar price * ",
    sketch:
      "To facilitate your payment, we provide payment in RMB.The above RMB amounts are calculated based on a combination of foreign exchange conversion rates and additional service fees incurred by providing RMB payment facilities.You can choose different payment methods provided on this page according to your actual situation and needs.",
    or: "or",
    transactionNo: "Transaction No.",
    alipayTransfer: "Alipay (General)",
    paymentInstructions: "Payment Instructions: ",
    alipaySpecial: "QR Code (Special): Payment must be completed within 2 hours after this order is submitted, otherwise the QR code will be invalid;",
    alipayGeneral: 'QR Code(General): "Transaction No." shall be indicated when making the payment, the QR code will not expire.',
  },
};
